module.exports = __webpack_public_path__ + "img/phase1-2012-03.629d6745.jpg";